/*
eWorldES Proprietary Software
Copyright (C) 2025 eWorldES. All rights reserved.

This software is proprietary to eWorldES and is protected by copyright laws and international treaties.
You may not use, copy, modify, distribute, or disclose this software without explicit written permission from eWorldES.
Any unauthorized use or reproduction of this software is strictly prohibited and may result in legal action.

License Agreement:
By using this software, you agree to be bound by the terms of the eWorldES Proprietary Software License Agreement.
For a copy of the agreement, visit https://eworldes.com/ or contact eWorldES directly for more information.

This software is provided "AS IS" without warranty of any kind, express or implied, including but not limited to the warranties of
merchantability, fitness for a particular purpose, or non-infringement. In no event shall eWorldES be liable for any damages
arising out of the use of this software, even if eWorldES has been advised of the possibility of such damages.

For inquiries or requests regarding this software, please contact eWorldES at:
Email: info@eworldes.com
Website: https://eworldes.com/
*/
import { Checkbox, FormControlLabel } from "@mui/material";
import React from "react";
import { CheckboxWrapperProps } from "./ICheckbox"; // Import the interface

const CheckboxWrapper: React.FC<CheckboxWrapperProps> = ({
  label,
  checked,
  onChange,
  disabled = false,
  size = "medium",
  color = "primary",
  required = false,
  ...rest
}) => {
  const renderLabel = (
    <span>
      {label}
      {required && <span style={{ color: "#F44336", marginRight: 2 }}> *</span>}
    </span>
  );
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          size={size}
          color={color}
          {...rest} // Spread other props (e.g., sx) to Checkbox
        />
      }
      label={renderLabel}
    />
  );
};

export default CheckboxWrapper;
